import styled from "styled-components";

export const FunnelPrices = styled.div`
    width: 100%;
    margin-bottom: 30px;
`;